<div class="w-full">
  @if (!currentFile() || errorMessage()) {
  <div (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)"
    [class.drag-over]="isDragOver()"
    class="dropzone flex items-center justify-center border-2 border-dashed border-gray-300 dark:border-zinc-700 rounded-xl px-3 h-[48px] transition-all duration-300 bg-white/5 dark:bg-black/5 hover:border-blue-500 hover:bg-blue-500/5 cursor-pointer relative">
    <input type="file" [accept]="accept()" (change)="onFileSelected($event)"
      class="absolute inset-0 opacity-0 cursor-pointer w-full h-full z-10" />
    <div class="flex items-center space-x-2 pointer-events-none">
      <mat-icon class="text-black dark:text-white scale-90 flex-shrink-0">cloud_upload</mat-icon>
      <span class="font-semibold text-xs text-gray-700 dark:text-zinc-300">
        {{ label() }}
      </span>
      <span class="text-[10px] text-gray-400 dark:text-zinc-500 hidden sm:inline">
        — {{ 'common.dragDrop' | transloco }}
      </span>
    </div>
  </div>
  } @else {
  <div
    class="file-info-card flex items-center justify-between border border-gray-200 dark:border-zinc-800 rounded-xl px-3 h-[48px] bg-white/50 dark:bg-zinc-900/50 backdrop-blur-md">
    <div class="flex items-center space-x-2 truncate mr-2">
      <div
        class="p-1 bg-black/5 dark:bg-white/10 rounded text-black dark:text-white flex-shrink-0 flex items-center justify-center">
        <mat-icon class="scale-75 text-black dark:text-white flex-shrink-0">insert_drive_file</mat-icon>
      </div>
      <div class="truncate flex items-baseline space-x-1.5">
        <p class="text-xs font-semibold text-gray-800 dark:text-zinc-200 truncate">
          {{ currentFile()?.name }}
        </p>
        <p class="text-[9px] text-gray-400 dark:text-zinc-500 flex-shrink-0 font-mono">
          ({{ (currentFile()?.size ?? 0) / 1024 / 1024 | number: '1.0-2' }} MB)
        </p>
      </div>
    </div>

    <div class="flex items-center space-x-2 flex-shrink-0">
      @if (uploading()) {
      <div class="flex items-center space-x-1 text-[10px] text-blue-500 font-semibold">
        <span class="animate-pulse">Uploading {{ progress() }}%</span>
      </div>
      } @else {
      <div class="flex items-center space-x-0.5 text-green-500 text-[10px] font-semibold">
        <mat-icon class="scale-75 text-green-500 flex-shrink-0">check_circle</mat-icon>
        <span class="hidden sm:inline">{{ 'common.uploaded' | transloco }}</span>
      </div>
      }

      @if (!uploading()) {
      <button type="button" (click)="clearFile()"
        class="p-1 hover:bg-gray-100 dark:hover:bg-zinc-800 rounded-full text-black dark:text-white hover:opacity-80 transition-colors duration-200 flex items-center justify-center"
        [attr.aria-label]="'common.removeFile' | transloco">
        <mat-icon class="scale-75 text-black dark:text-white flex-shrink-0">close</mat-icon>
      </button>
      }
    </div>
  </div>
  }

  @if (errorMessage()) {
  <div class="flex items-center space-x-2 text-red-500 text-xs mt-1.5 font-medium">
    <mat-icon class="scale-75 text-red-500 flex-shrink-0">error</mat-icon>
    <span>{{ errorMessage() }}</span>
  </div>
  }
</div>